export const QUOTE_STATE_IN_PROGRESS = 'in_progress';
export const QUOTE_STATE_WON = 'won';
export const QUOTE_STATE_LOST = 'lost';
export const QUOTE_STATE_ABANDONED = 'abandoned';

export const QUOTE_FROZEN_STATES = [QUOTE_STATE_WON, QUOTE_STATE_LOST, QUOTE_STATE_ABANDONED];
